import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { TimelineConstants } from '../store/timeline.constants'
import { IFilterChips, ITimelineState } from '../store/timeline.types'
import * as actions from '../store/timeline.actions'

export function* setFiltersChips() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items, filterChips } = timeline
  if (items) {
    const itemTypes = items.map((item) => item.itemType)
    const uniqueItemTypes = new Set(itemTypes)
    const updatedFilterChips: IFilterChips = []
    uniqueItemTypes.forEach((itemType) => {
      if (itemType === 'Procedures') {
        updatedFilterChips.push({
          itemType,
          filterAction: TimelineConstants.FILTER_PROCEDURES,
          isSelected: getSelectedType(itemType, filterChips),
        })
      } else if (itemType === 'Medications') {
        updatedFilterChips.push({
          itemType,
          filterAction: TimelineConstants.FILTER_MEDICATIONS,
          isSelected: getSelectedType(itemType, filterChips),
        })
      } else if (itemType === 'Times') {
        updatedFilterChips.push({
          itemType,
          filterAction: TimelineConstants.FILTER_TIMES,
          isSelected: getSelectedType(itemType, filterChips),
        })
      } else if (itemType === 'Assessments') {
        updatedFilterChips.push({
          itemType,
          filterAction: TimelineConstants.FILTER_ASSESSMENTS,
          isSelected: getSelectedType(itemType, filterChips),
        })
      } else if (itemType === 'Vitals') {
        updatedFilterChips.push({
          itemType,
          filterAction: TimelineConstants.FILTER_VITALS,
          isSelected: getSelectedType(itemType, filterChips),
        })
      } else if (itemType === 'ECG') {
        updatedFilterChips.push({
          itemType,
          filterAction: TimelineConstants.FILTER_ECG,
          isSelected: getSelectedType(itemType, filterChips),
        })
      }
    })
    yield put(actions.setFiltersChips(updatedFilterChips))
    yield put(actions.updateFilteredItems())
  }
}

export function* setFilterChipsSaga() {
  yield takeLatest([TimelineConstants.SET_ACTIVITY_LOG], setFiltersChips)
}

function getSelectedType(itemType: string, filterChips: IFilterChips): boolean {
  if (filterChips.length) {
    const chip = filterChips.filter((chip) => chip.itemType === itemType)[0]
    return chip?.isSelected
  } else {
    return false
  }
}
